import produce from 'immer';
import {
    BEFORE_AUTH,
    CART_ACCOUNT,
    CART_AUTO_UPGRADE,
    CART_CURRENCY,
    CART_DOMAINS,
    CART_EXTRA,
    CART_FLAGS,
    CART_INCLUDE_PRODUCT,
    CART_PERIOD,
    CART_RENEW,
    CART_SAVE_PRODUCTS,
    CART_TARIFF,
    FEATURED,
    FROM_QUERY,
    SYNC_FEATURED_PRODUCTS,
    CART_SELECTED_CUSTOM_BILLS,
    UI_MODE,
} from '../constants/cartContstants';
import _ from 'underscore';
import { default as _u } from 'underscore';
import applyAccountPeriods from '../../mutators/applyAccountPeriods';

const initialState = {
    period: '',
    currency: 'USD',
    tariffFromQuery: null,
    periodFromQuery: null,
    extraFromQuery: null,
    tariffBeforeAuth: null,
    periodBeforeAuth: null,
    currencyFromQuery: null,
    uiModeFromQuery: null,
    domainsFromQuery: null,
    accountFromQuery: null,
    domains: null,
    account: null,
    renew: true,
    autoUpgrade: true,
    products: {},
    featuredProductsFromQuery: null,
    flags: {
        initialized: false,
        featuredAutoSelect: false,
        featuredAutoSelectProduct: {},
    },
    selectedCustomBills: [],
};

export default produce((draft = initialState, action) => {
    const { type, data } = action;

    switch (type) {
        case CART_PERIOD:
            if (data.includedIds) {
                data.includedIds?.forEach((product_id) => {
                    draft.products[product_id] = assignPeriod(
                        draft.products[product_id],
                        data.period
                    );
                });
            } else {
                draft.products[data.product_id] = assignPeriod(
                    draft.products[data.product_id],
                    data.period
                );
            }
            break;
        case CART_CURRENCY:
            draft.currency = data.currency;
            break;
        case CART_DOMAINS:
            draft.domains = data?.domains?.map((domain) => domain?.value);
            break;
        case CART_ACCOUNT:
            draft.account = data?.account;
            if (data?.merge && data?.productId) {
                draft.products[data?.productId] = {
                    ...draft.products[data?.productId],
                    ...data?.merge,
                };
            }
            applyAccountPeriods([draft?.period], action, false);
            applyAccountPeriods(draft?.periods ? draft?.periods[data?.productId] : null, action);
            break;
        case CART_TARIFF:
            if (data?.tariffs?.length) {
                data.tariffs.forEach(({ tariff, product_id }) => {
                    draft.products[product_id] = {
                        ...draft.products[product_id],
                        tariff: tariff,
                        oldTariff: draft.products[product_id]?.tariff,
                    };
                });
            } else {
                if (data.product_id) {
                    draft.products[data.product_id] = {
                        ...draft.products[data.product_id],
                        tariff: data.tariff,
                        oldTariff: draft.products[data.product_id]?.tariff,
                        tariffCurrent: data?.tariffCurrent
                            ? data?.tariffCurrent
                            : draft?.products[data.product_id]?.tariffCurrent,
                    };
                }
            }
            break;
        case SYNC_FEATURED_PRODUCTS:
            if (data.includedIds) {
                data.includedIds?.forEach((product_id) => {
                    draft.products[product_id] = assignPeriod(
                        draft.products[product_id],
                        draft.products[data?.mainProductId]?.period
                    );
                    draft.products[product_id] = {
                        ...draft.products[product_id],
                    };
                });
            }
            if (data?.tariffs?.length) {
                data.tariffs.forEach(({ tariff, product_id }) => {
                    draft.products[product_id] = {
                        ...draft.products[product_id],
                        tariff: tariff,
                        oldTariff: draft.products[product_id]?.tariff,
                    };
                });
            }
            break;
        case CART_PERIOD + FROM_QUERY:
            draft.periodFromQuery =
                data?.period && data?.interval ? `${data.interval} ${data.period}` : '';
            break;
        case CART_EXTRA + FROM_QUERY:
            draft.extraFromQuery = !!data?.extra;
            break;
        case FEATURED + FROM_QUERY:
            if (data?.featured === '*') {
                draft.featuredProductsFromQuery = '*';
            } else if (data?.featured && _.isString(data?.featured)) {
                draft.featuredProductsFromQuery = data?.featured
                    ?.split(',')
                    ?.map((id) => Number(id));
            } else if (data?.featured && Array.isArray(data?.featured)) {
                draft.featuredProductsFromQuery = data.featured?.map((id) => Number(id));
            } else if (data.hasOwnProperty('featured') && typeof data?.featured === 'boolean') {
                draft.featuredProductsFromQuery = data.featured;
            }
            break;
        case CART_TARIFF + FROM_QUERY:
            draft.tariffFromQuery = +data.tariff_id || 0;
            break;
        case CART_PERIOD + BEFORE_AUTH:
            draft.periodBeforeAuth = data?.name || '';
            break;
        case CART_TARIFF + BEFORE_AUTH:
            draft.tariffBeforeAuth = +data?.tariff_id || 0;
            break;
        case CART_CURRENCY + FROM_QUERY:
            draft.currencyFromQuery = data.currency || 'USD';
            break;
        case UI_MODE + FROM_QUERY:
            draft.uiModeFromQuery = data.ui_mode;
            break;
        case CART_DOMAINS + FROM_QUERY:
            if (Array.isArray(data?.domains)) {
                draft.domainsFromQuery = data.domains;
            } else if (typeof data?.domains === 'string') {
                draft.domainsFromQuery = data.domains
                    .split(',')
                    ?.filter(Boolean)
                    .map((id) => Number(id));
            } else {
                draft.domainsFromQuery = [];
            }
            break;
        case CART_ACCOUNT + FROM_QUERY:
            draft.accountFromQuery = data?.account;
            applyAccountPeriods([draft?.period], action, false);
            applyAccountPeriods(draft?.periods ? draft?.periods[data?.productId] : null, action);
            break;
        case CART_EXTRA:
            draft.extraFromQuery = !!data?.value;
            if (data?.includedIds?.length) {
                data.includedIds.forEach((product_id) => {
                    const product = draft.products[product_id];
                    draft.products[product_id] = {
                        ...product,
                        includeExtra: data.value,
                    };
                });
            }
            if (data.product_id) {
                draft.products[data.product_id] = {
                    ...draft.products[data.product_id],
                    includeExtra: data.value,
                };
            }
            break;
        case CART_RENEW:
            draft.renew = data.renew;
            break;
        case CART_AUTO_UPGRADE:
            draft.autoUpgrade = data.autoUpgrade;
            break;
        case CART_SAVE_PRODUCTS:
            draft.products = null;
            const products = data.products
                .map((product) => {
                    return {
                        ...product,
                        includeExtra: product?.extra_package_name
                            ? (product?.includeExtra ?? !!draft.extraFromQuery ?? true)
                            : null,
                        isIncluded: product?.product_id === +data.id,
                        isMain: product?.product_id === +data.id,
                        renew: true,
                    };
                })
                .reduce((acc, product) => {
                    acc[product?.product_id] = { ...product };

                    return acc;
                }, {});

            draft.products = {
                ...draft.products,
                ...products,
            };
            break;
        case CART_INCLUDE_PRODUCT:
            draft.products[data.product_id] = {
                ...draft.products[data.product_id],
                isIncluded: data.value,
            };
            draft.featuredProductsFromQuery = Object.values(draft.products)
                ?.filter((item) => !!item?.isIncluded)
                ?.map((item) => item?.product_id);
            break;
        case CART_FLAGS:
            draft.flags = _u.extend(draft.flags, data.flags, {});
            break;
        case CART_SELECTED_CUSTOM_BILLS:
            draft.selectedCustomBills = data;
        default:
            return draft;
    }
});

const assignPeriod = (product, period) => {
    let periodTarget = period;
    if (product.product_id !== period?.product_id) {
        const periods = product?.tariff?.periods;
        const periodMatch = _u.find(periods, {
            interval: period?.billing_period,
            interval_count: period?.interval,
        });
        if (periodMatch) {
            // Emulation of data structure as it's used in the UI component (selector).
            periodTarget = {
                isDisabled: false,
                name: `${periodMatch.interval_count} ${product.tariff.billing_period}`,
                discount: periodMatch?.interval_discount,
                unit: periodMatch?.interval_discount_unit,
                billing_period: product.tariff.billing_period,
                interval: periodMatch.interval_count,
                product_id: product.tariff.product_id,
            };
        } else {
            periodTarget =
                _u.find(periods, {
                    interval: period?.billing_period,
                }) || _u.find(periods, Boolean);
        }
    }

    return {
        ...product,
        period: {
            ...periodTarget,
            product_id: product?.product_id,
        },
        oldPeriod: product?.period,
    };
};
